import { FiSearch, FiUser, FiShoppingCart, FiMenu, FiX } from 'react-icons/fi';

export default function HeaderActions({ cartCount = 0, mobileOpen, onMenuToggle }) {
  return <div className="header-actions">
    <a className="icon-button action-desktop" href="/search" aria-label="Search"><FiSearch /></a>
    <a className="icon-button action-desktop" href="/account" aria-label="Account"><FiUser /></a>
    <a className="icon-button cart-button" href="/cart" aria-label={`Shopping cart, ${cartCount} items`}><FiShoppingCart /><span className="cart-badge">{cartCount}</span></a>
    <a className="shop-button action-desktop" href="/products">SHOP NOW</a>
    <button className="icon-button menu-toggle" type="button" aria-label={mobileOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileOpen} aria-controls="mobile-navigation" onClick={onMenuToggle}>{mobileOpen ? <FiX /> : <FiMenu />}</button>
  </div>;
}
